import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Forecastsuppliers*/
export const registerForecastsupplier = async (forecastData) => {
  try {
    const response = await api.post("/forecast", forecastData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchForecastsuppliersFromAPI = async (page = 1, perPage = 10, search = "") => {
  try {
    const response = await api.get("/forecast/header", {
      params: { page, per_page: perPage, ...search },
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteForecastsuppliersFromAPI = async (forecastId) => {
  try {
    const response = await api.delete(`/forecast/${forecastId}`, {
      params: { forecast_id: forecastId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const registerFeedbackForecastsupplier = async (forecastData) => {
  try {
    const response = await api.post("/forecast/submit-feedback", forecastData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchForecastsuppliersById = async (forecastId) => {
  try {
    const response = await api.get(`/forecast/${forecastId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data forecast", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateForecastsupplier = async (id, forecastData) => {
  try {
    const response = await api.put(`/forecast/${id}`, forecastData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const uploadForecastsupplierFileToAPI = async (formData) => {
  try {
    const response = await api.post("/inventories/submit-excel-forecast", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload forecast file", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const downloadForecastsupplierFileFromAPI = async (fileType, vendorCode, forecastMonth, commodity, plant) => {
  try {
    // Convert forecastMonth from "YYYY-MM" to "YYYYMM"
    const formattedForecastsupplierMonth = forecastMonth.replace("-", "");

    const response = await api.post(
      `/inventories/download/${fileType}/${vendorCode}/${formattedForecastsupplierMonth}/${commodity}/${plant || ''}`
    );


    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;
      
      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download forecast file", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};
